module.exports = __webpack_public_path__ + "assets/376d4f2d1a4061d7804aa661d1182d26.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/denoms/denom-9.mp3
 ** module id = 356
 ** module chunks = 0
 **/